import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	deactivated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	anonymousOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noValueTextExperiment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userWithDelegator: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userWithDelegatorAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	deactivated: {
		id: 'issue-field-single-user-picker-readview-full.single-user-picker.deactivated',
		defaultMessage: 'Deactivated',
		description:
			'Text displayed to the right of the user name of a deactivated user in user picker field',
	},
	anonymousOption: {
		id: 'issue-field-single-user-picker-readview-full.single-user-picker.anonymous-option',
		defaultMessage: 'Anonymous',
		description: 'Represents an anonymous user on this Jira instance',
	},
	noValueTextExperiment: {
		id: 'issue-field-single-user-picker-readview-full.single-user-picker.no-value-text-experiment',
		defaultMessage: 'Add user',
		description: 'Message when the field has no value',
	},
	userWithDelegator: {
		id: 'issue-field-single-user-picker-readview-full.single-user-picker.user-with-delegator',
		defaultMessage: '{name} with {delegator}',
		description:
			'Text displayed when showing a user with their delegator, where {name} is the user name and {delegator} is the delegator display name',
	},
	userWithDelegatorAriaLabel: {
		id: 'issue-field-single-user-picker-readview-full.single-user-picker.user-with-delegator-aria-label',
		defaultMessage: 'User with delegator',
		description: 'Accessibility label for text showing a user with their delegator',
	},
});
export default messages;
